module.exports = __webpack_public_path__ + "img/chess.9e51dd18.svg";